import { useEffect, useState } from 'react';

export function useValorDiferido<T>(valor: T, milisegundos = 350): T {
  const [diferido, setDiferido] = useState(valor);

  useEffect(() => {
    const espera = setTimeout(() => setDiferido(valor), milisegundos);
    return () => clearTimeout(espera);
  }, [valor, milisegundos]);

  return diferido;
}
